import mkReduxActionApiRequest from 'scripts/util/redux/mkReduxActionApiRequest'
import { createSelector } from 'reselect'

export const LOAD_LOCATION_SUGGESTIONS =
  'ksk001/estateOverview/LOAD_LOCATION_SUGGESTIONS'
export const LOAD_LOCATION_SUGGESTIONS_SUCCESS =
  'ksk001/estateOverview/LOAD_LOCATION_SUGGESTIONS_SUCCESS'
export const LOAD_LOCATION_SUGGESTIONS_FAILURE =
  'ksk001/estateOverview/LOAD_LOCATION_SUGGESTIONS_FAILURE'
export const LOAD_LOCATION_SUGGESTIONS_ABORTED =
  'ksk001/estateOverview/LOAD_LOCATION_SUGGESTIONS_ABORTED'

export const initialState = {
  abortController: null,
  businessAreaSuggestions: null,
  allAreaSuggestions: null,
  error: null,
  isLoading: false,
}

export default (state = initialState, action) => {
  const { abortController, inBusinessArea, payload, type } = action

  switch (type) {
    case LOAD_LOCATION_SUGGESTIONS:
      return {
        ...state,
        isLoading: true,
        abortController,
      }
    case LOAD_LOCATION_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        abortController: null,
        [inBusinessArea
          ? 'businessAreaSuggestions'
          : 'allAreaSuggestions']: payload,
      }
    case LOAD_LOCATION_SUGGESTIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        abortController: null,
        error: payload.error,
      }
    case LOAD_LOCATION_SUGGESTIONS_ABORTED:
      return {
        ...state,
        isLoading: false,
        abortController: null,
      }
    default:
      return state
  }
}

export const loadLocationSuggestions = (
  searchString = '',
  inBusinessArea = true
) => (dispatch, getState) => {
  const {
    locationSuggestions: { abortController: previousAbortController },
  } = getState()

  const area = inBusinessArea ? 'business-area' : 'all'

  return mkReduxActionApiRequest({
    apiFetchArgs: {
      path: `/dhsv/v1/location-suggestions/${area}/${searchString}`,
    },
    types: {
      initial: LOAD_LOCATION_SUGGESTIONS,
      success: LOAD_LOCATION_SUGGESTIONS_SUCCESS,
      failure: LOAD_LOCATION_SUGGESTIONS_FAILURE,
      aborted: LOAD_LOCATION_SUGGESTIONS_ABORTED,
    },
    dispatch,
    previousAbortController,
    extraActionProperties: { inBusinessArea },
  })
}

export const sLocationSuggestions = createSelector(
  state => state.locationSuggestions,
  (_, props) => props.inBusinessArea,
  (locationSuggestions, inBusinessArea) =>
    inBusinessArea === false
      ? locationSuggestions.allAreaSuggestions
      : locationSuggestions.businessAreaSuggestions
)

export const sLocationSuggestionsEmpty = createSelector(
  sLocationSuggestions,
  ({ districts, municipalities, streets }) =>
    [districts, municipalities, streets].every(s => s.length === 0)
)
